// #ifdef H5
import WechatSDK from 'weixin-js-sdk';
// #endif

export default {
  /**
   * 获取详情地址文本
   * @param data
   * @returns
   */
  getText: (data: AnyObject) => {
    if (!data?.province) return '';
    return `${data.province}${data.city}${data.district || data.customFields?.district || ''}${
      data.streetLine1
    }${data.streetLine2}`;
  },
  /**
   * 获取用户收货地址 uni.chooseAddress
   */
  getUniAddress: () => {
    return new Promise((resolve, reject) => {
      // #ifdef MP-WEIXIN
      uni.chooseAddress({
        success: (res) => {
          resolve(res);
        },
        fail: (err) => {
          reject(err);
        },
      });
      // #endif

      // #ifdef H5
      if (typeof WechatSDK === 'undefined') {
        reject('微信JS SDK未加载');
        return;
      }

      WechatSDK.openAddress({
        success: (res) => {
          // 统一返回格式，与 uni.chooseAddress 保持一致
          resolve({
            errMsg: 'chooseAddress:ok',
            userName: res.userName,
            telNumber: res.telNumber,
            provinceName: res.provinceName,
            cityName: res.cityName,
            countyName: res.countryName, // H5 返回的是 countryName（区县），映射为 countyName
            streetName: '',              // H5 无此字段
            detailInfo: res.detailInfo,
            postalCode: res.postalCode || '',
            nationalCode: res.nationalCode || '',
          });
        },
        cancel: () => {
          reject('用户取消选择');
        },
        fail: (err) => {
          reject(err);
        },
      });
      // #endif
    });
  },
};
